import { motion } from "framer-motion";

/**
 * Editorial marquee — slow horizontal drift, warm beige rail, dark olive type.
 */
const WORDS = [
  "Original Skin",
  "·",
  "Wear Your Archetype",
  "·",
  "Mind. Body. Earth.",
  "·",
  "Genesis 2:7",
  "·",
  "EarthTone",
  "·",
  "Formed From The Dust",
  "·",
];

export default function Marquee() {
  const items = [...WORDS, ...WORDS, ...WORDS];
  return (
    <section
      className="relative bg-[#e8dcc4] py-8 md:py-10 overflow-hidden border-y border-[#362b28]"
      data-testid="marquee-section"
      aria-label="brand marquee"
    >
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="flex whitespace-nowrap marquee-track"
      >
        {items.map((w, i) => (
          <span
            key={i}
            className="font-serif italic text-[#2c402b] text-[42px] md:text-[68px] leading-none px-8 md:px-14"
          >
            {w}
          </span>
        ))}
        {items.map((w, i) => (
          <span
            key={`b-${i}`}
            aria-hidden
            className="font-serif italic text-[#2c402b] text-[42px] md:text-[68px] leading-none px-8 md:px-14"
          >
            {w}
          </span>
        ))}
      </motion.div>
    </section>
  );
}
